/* @flow */
import Entity from 'lib/Entity';

export default class Unsubscribe extends Entity {
  initialize() {
    // $FlowIssue
    this.url = '/email_unsubscribe';
  }

  getEmail() {
    return this.get('email');
  }

  getToken() {
    return this.get('token');
  }

  getOptions() {
    return this.get('options');
  }

  unsubscribe() {
    return this.sync('POST', this, { data: { token: this.getToken() } });
  }
}
